import { createPortal } from "react-dom";

// Renders children into document.body so fixed overlays (panels, voice call,
// briefing) escape any parent stacking context (e.g. <main> z-index).
export function Portal({ children }) {
  if (typeof document === "undefined") return null;
  return createPortal(children, document.body);
}
